module.exports = __webpack_public_path__ + "img/lottery_award_title.ce3fc0e1.png";